export enum BotPeakStrategy {
  RATCHET = 'RATCHET',
  DAILY_OPEN = 'DAILY_OPEN',
  N_DAY_HIGH = 'N_DAY_HIGH',
  MOVING_AVG = 'MOVING_AVG',
}
